<template>
    <div>
        <SalesReportTemplate
            title="Drawer Action Report"
            :columns="columns"
            fetchRoute="/reports/drawer-action-report"
            reportTypeCode="DRAWER_ACTION_REPORT"
            permission="CMS_VIEW_REPORT_DRAWER_ACTION_REPORT"
            @onResponse="handleResponse"
        >
            <template #filters>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <!-- Employee Filter -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Employee</label>
                        <select 
                            v-model="selectedEmployee" 
                            class="w-full border border-gray-300 rounded-md px-3 py-2"
                            @change="updateFilters"
                        >
                            <option value="">All Employees</option>
                            <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                                {{ employee.name }}
                            </option>
                        </select>
                    </div>
                    
                    <!-- Action Type Filter -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Action Type</label>
                        <select 
                            v-model="selectedActionType" 
                            class="w-full border border-gray-300 rounded-md px-3 py-2"
                            @change="updateFilters"
                        >
                            <option value="">All Actions</option>
                            <option value="open">Open</option>
                            <option value="close">Close</option>
                        </select>
                    </div>
                    
                    <!-- Drawer Filter -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Drawer</label>
                        <select 
                            v-model="selectedDrawer" 
                            class="w-full border border-gray-300 rounded-md px-3 py-2"
                            @change="updateFilters"
                        >
                            <option value="">All Drawers</option>
                            <option v-for="drawer in drawers" :key="drawer.id" :value="drawer.id">
                                {{ drawer.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </template>
        </SalesReportTemplate>
    </div>
</template>

<script>
import SalesReportTemplate from './SalesReportTemplate.vue'
import { mapState } from 'vuex'
import { http } from '@/utils/http'

export default {
    name: 'DrawerActionReport',
    components: {
        SalesReportTemplate
    },
    data() {
        return {
            selectedEmployee: '',
            selectedActionType: '',
            selectedDrawer: '',
            employees: [],
            drawers: [],
            columns: [
                { key: 'formattedDate', title: 'Date' },
                { key: 'action_type', title: 'Action Type' },
                { key: 'drawer_name', title: 'Drawer' },
                { key: 'user_name', title: 'Employee' },
                { key: 'is_manual_open', title: 'Manual Open' },
                { key: 'reason', title: 'Reason' },
                { key: 'notes', title: 'Notes' },
                { key: 'device_id', title: 'Device' },
            ]
        }
    },
    computed: {
        ...mapState('misc', ['warehouses'])
    },
    mounted() {
        this.loadEmployees()
        this.loadDrawers()
    },
    methods: {
        async loadEmployees() {
            try {
                const response = await http.get('/users')
                this.employees = response.data.result || []
            } catch (error) {
                console.error('Error loading employees:', error)
            }
        },
        async loadDrawers() {
            try {
                const response = await http.get('/safe-drawers')
                this.drawers = response.data.result || []
            } catch (error) {
                console.error('Error loading drawers:', error)
            }
        },
        updateFilters() {
            // Emit filter changes to parent component
            this.$emit('filtersChanged', {
                employee_user_ids: this.selectedEmployee,
                action_type: this.selectedActionType,
                drawer_ids: this.selectedDrawer
            })
        },
        handleResponse(data) {
            // Handle response data if needed
            console.log('Drawer action report data:', data)
        }
    }
}
</script>

<style scoped>
/* Add any custom styles here */
</style> 